<template>
  <form class="register-form" @submit.prevent="handleSubmit">
    <!-- 姓名 -->
    <div class="form-item">
      <label class="form-item-label" for="register-name">姓名</label>
      <div class="form-item-control">
        <input
          v-model="formData.name"
          type="text"
          id="register-name"
          class="input-base"
          placeholder="请输入真实姓名"
          :class="{ 'input-error': errors.name }"
          maxlength="20"
        />
        <div class="form-item-error" v-if="errors.name">{{ errors.name }}</div>
      </div>
    </div>

    <!-- 手机号 -->
    <div class="form-item">
      <label class="form-item-label" for="register-phone">手机号</label>
      <div class="form-item-control">
        <div class="phone-input-wrapper">
          <input
            v-model="formData.phone"
            type="tel"
            id="register-phone"
            class="input-base phone-input"
            placeholder="请输入11位手机号"
            :class="{ 'input-error': errors.phone }"
            $input="validatePhone"
            maxlength="11"
          />
        </div>
        <div class="form-item-error" v-if="errors.phone">
          {{ errors.phone }}
        </div>
      </div>
    </div>
    <!-- 部门选择 -->
    <div class="form-item">
      <label class="form-item-label" for="register-department">所属医院</label>
      <div class="form-item-control">
        <select
          v-model="formData.department"
          id="register-department"
          class="input-base select-input"
          :class="{
            'input-error': errors.department,
            'select-input': formData.department == '',
            'select-input2': formData.department != '',
          }"
        >
          <option value="">请选择所属医院</option>
          <option
            v-for="dept in departments"
            :key="dept.value"
            :value="dept.value"
          >
            {{ dept.label }}
          </option>
        </select>
        <div class="form-item-error" v-if="errors.department">
          {{ errors.department }}
        </div>
      </div>
    </div>

    <!-- 验证码 -->
    <!-- <div class="form-item">
      <label class="form-item-label" for="register-code">验证码</label>
      <div class="form-item-control">
        <div class="code-input-wrapper">
          <input
            v-model="formData.code"
            type="text"
            id="register-code"
            class="input-base code-input"
            placeholder="请输入6位验证码"
            :class="{ 'input-error': errors.code }"
            maxlength="6"
          />
          <button
            type="button"
            class="send-code-btn"
            :disabled="countdown > 0 || !isPhoneValid"
            @click="sendCode"
          >
            {{ countdownText }}
          </button>
        </div>
        <div class="form-item-error" v-if="errors.code">{{ errors.code }}</div>
      </div>
    </div> -->

    <!-- 提交按钮 -->
    <div class="form-item">
      <button
        type="submit"
        class="btn-error submit-btn"
        :disabled="isSubmitting"
      >
        {{ isSubmitting ? "注册中..." : "立即注册" }}
      </button>
    </div>

    <!-- 切换登录 -->
    <div class="switch-form">
      <span>已有账号？</span>
      <button type="button" class="switch-btn" @click="emit('switch-to-login')">
        立即登录
      </button>
    </div>
  </form>
</template>

<script setup>
import { useCommonStore } from "@/stores/common";
import { ref, reactive, computed, onUnmounted } from "vue";
import { ElMessage } from "element-plus";

const emit = defineEmits(["switch-to-login"]);
const commonStore = useCommonStore();
console.log();
// 部门列表
let departments = ref([]);
commonStore.getHospitalList().then((res) => {
  departments.value = res.data.map((v) => {
    return {
      value: v.hospital,
      label: v.hospital,
    };
  });
});
// 表单数据
const formData = reactive({
  name: "",
  phone: "",
  department: "",
  code: "",
});

// 表单错误
const errors = reactive({
  name: "",
  phone: "",
  department: "",
  code: "",
});

// 倒计时
const countdown = ref(0);
let timer = null;

// 提交状态
const isSubmitting = ref(false);

// 计算属性
const isPhoneValid = computed(() => {
  return /^1[3-9]\d{9}$/.test(formData.phone);
});

const countdownText = computed(() => {
  return countdown.value > 0 ? `${countdown.value}秒后重新获取` : "获取验证码";
});

// 手机号验证
const validatePhone = () => {
  if (!formData.phone) {
    errors.phone = "请输入手机号";
  } else if (!isPhoneValid.value) {
    errors.phone = "手机号格式不正确";
  } else {
    errors.phone = "";
  }
};

// 发送验证码
const sendCode = async () => {
  if (!isPhoneValid.value) {
    errors.phone = "请输入正确的手机号";
    return;
  }
  // 模拟发送验证码
  // 开始倒计时
  commonStore.getVerificationCode(formData.phone).then((res) => {
    if (res.result == "failure") {
      ElMessage.error(res.msg);
      return;
    }
    countdown.value = 60;
    timer = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
        timer = null;
      }
    }, 1000);
  });
};

// 表单验证
const validateForm = () => {
  let isValid = true;

  // 验证姓名
  if (!formData.name.trim()) {
    errors.name = "请输入姓名";
    isValid = false;
  } else if (formData.name.trim().length < 2) {
    errors.name = "姓名至少2个字符";
    isValid = false;
  } else {
    errors.name = "";
  }

  // 验证手机号
  validatePhone();
  if (!isPhoneValid.value) {
    isValid = false;
  }

  // 验证部门
  if (!formData.department) {
    errors.department = "请选择所属医院";
    isValid = false;
  } else {
    errors.department = "";
  }

  // // 验证验证码
  // if (!formData.code) {
  //   errors.code = "请输入验证码";
  //   isValid = false;
  // } else if (formData.code.length !== 6) {
  //   errors.code = "验证码必须为6位数字";
  //   isValid = false;
  // } else {
  //   errors.code = "";
  // }

  return isValid;
};

// 表单提交
const handleSubmit = async () => {
  console.log(123);
  if (!validateForm()) {
    return;
  }
  // 模拟注册
  isSubmitting.value = true;
  commonStore
    .registered(formData.name, formData.phone, formData.department)
    .then((res) => {
      isSubmitting.value = false;
      if (res.result == "success") {
        ElMessage.success("注册成功！请登录");
        setTimeout(() => {
          emit("switch-to-login");
        }, 1000);
        return;
      } else {
        ElMessage.error(res.msg);
      }
    });
};

// 组件卸载时清除定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});
</script>

<style lang="scss" scoped>
@use "../styles/variables.scss" as *;
@use "../styles/common.scss" as *;
.select-input {
  color: #757575;
  option {
    color: #000 !important;
  }
}
.select-input2 {
  color: #000 !important;
}
.register-form {
  .form-item {
    display: flex;
    .form-item-label {
      line-height: 40px;
      width: 90px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }

  .phone-input-wrapper {
    display: flex;
    align-items: center;

    .country-code {
      padding: 0 12px;
      height: 40px;
      line-height: 40px;
      background-color: #f5f5f5;
      border: 1px solid $border-color;
      border-right: none;
      border-radius: $border-radius-sm 0 0 $border-radius-sm;
      color: $text-secondary-color;
    }

    .phone-input {
      border-radius: $border-radius-sm;
    }
  }

  .select-input {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%23999' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 36px;
    cursor: pointer;

    &:focus {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%231890ff' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10l-5 5z'/%3E%3C/svg%3E");
    }
  }

  .code-input-wrapper {
    display: flex;
    gap: 12px;

    .code-input {
      flex: 1;
    }

    .send-code-btn {
      @include btn-secondary();
      min-width: 120px;
      white-space: nowrap;

      &:disabled {
        background-color: #f5f5f5;
        color: $text-secondary-color;
        border-color: $border-color;
      }
    }
  }

  .submit-btn {
    width: 100%;
    font-size: $font-size-lg;
    height: 44px;
  }

  .switch-form {
    text-align: center;
    margin-top: $margin-base;
    padding-top: $padding-sm;
    border-top: 1px solid $border-color;
    color: $text-secondary-color;

    .switch-btn {
      background: none;
      border: none;
      color: $error-color;
      cursor: pointer;
      font-size: $font-size-base;
      padding: 0;
      margin-left: 4px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.input-error {
  border-color: $error-color !important;

  &:focus {
    box-shadow: 0 0 0 2px fade($error-color, 20%) !important;
  }
}
</style>
